import Vue from 'vue';
import Vuex from 'vuex';
import { ERROR_CONFIG } from 'store/enums';
import ui from './modules/ui';
import guide from './modules/guide';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production' || process.env.MODE_VUE_DEVTOOLS === 'enabled';
// Fix: No Vuex store detected https://github.com/vuejs/vue-devtools/issues/405
Vue.config.devtools = debug;

const store = new Vuex.Store({
  state: {
    error: null
  },
  actions: {
    RESET_ERROR_PROPERTY({ commit }) {
      commit('RESET_ERROR_PROPERTY');
    }
  },
  mutations: {
    RESET_ERROR_PROPERTY(state) {
      state.error = null;
    },

    ERROR_OCCURRED(state, error) {
      const { status, data } = error.response || error;
      if (status === 500) {
        const { theme, logoUrl, phoneNumber, imageUrl, title, message } = ERROR_CONFIG[status];
        state.ui.theme = theme;
        state.ui.logoUrl = logoUrl;
        state.ui.phoneNumber = phoneNumber;
        state.error = { imageUrl, title, message };
      } else {
        const { theme, logoUrl, phoneNumber } = data;
        state.ui.theme = theme;
        state.ui.logoUrl = logoUrl;
        state.ui.phoneNumber = phoneNumber;
        state.error = data;
      }
    }
  },
  modules: {
    ui,
    guide
  },
  strict: debug
});

export { store as default };
